export enum PromotionTypes {
  GET_PROMOTION = 'GET_PROMOTION',
}
